import { FC, useState } from "react";
import MagnifyingGlassIcon from "@heroicons/react/20/solid/MagnifyingGlassIcon";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PromptLibraryTable } from "@/modules/promptLibrary/components/promptLibraryTable";
import { PromptLibraryTab } from "@/modules/promptLibrary/promptLibrary.types";
import { List, Star } from "lucide-react";

export const PromptLibraryView: FC = () => {
  const [activeTab, setActiveTab] = useState<PromptLibraryTab>("all");
  const [searchPhrase, setSearchPhrase] = useState("");

  return (
    <div className="container">
      <Tabs defaultValue={"all"}>
        <TabsList className="mb-5 flex justify-start bg-transparent px-2">
          <div className="mr-3 flex">
            <TabsTrigger
              value={"all"}
              onClick={() => setActiveTab("all")}
              className="radius-0 group flex items-center rounded-none border-b-2 border-transparent px-4 py-4 text-sm font-medium text-gray-500 shadow-none hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:bg-ui-app-background data-[state=active]:text-desert-sand-700"
            >
              <List className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
              <span className="px-1">All</span>
            </TabsTrigger>
            <TabsTrigger
              value={"favorite"}
              onClick={() => setActiveTab("favourite")}
              className="radius-0 group flex items-center rounded-none border-b-2 border-transparent px-4 py-4 text-sm font-medium text-gray-500 shadow-none hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:bg-ui-app-background data-[state=active]:text-desert-sand-700"
            >
              <Star className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
              <span className="px-1">Favourite</span>
            </TabsTrigger>
          </div>
          <div>
            <div className="relative">
              <input
                type="text"
                placeholder="Search names or notes"
                className="min-w-96 max-w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchPhrase}
                onChange={e => setSearchPhrase(e.target.value)}
              />
              <div className="absolute right-3 top-1/2 -translate-y-1/2 transform">
                <MagnifyingGlassIcon className="w-5 text-gray-500" />
              </div>
            </div>
          </div>
        </TabsList>

        <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden bg-white p-5 shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <PromptLibraryTable activeTab={activeTab} searchPhrase={searchPhrase} />
            </div>
          </div>
        </div>
      </Tabs>
    </div>
  );
};
